import { render } from "./MyContactList.vue?vue&type=template&id=635c7803&scoped=true"
import script from "./MyContactList.vue?vue&type=script&lang=js"
export * from "./MyContactList.vue?vue&type=script&lang=js"

import "./MyContactList.vue?vue&type=style&index=0&id=635c7803&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635c7803"]])

export default __exports__